import { AlertConfigOperation, AlertConfigOperationNameMapping, ApiConsumersOperation, ApiConsumersOperationNameMapping, AuthOperation, AuthOperationNameMapping, DeviceAlarmOperation, DeviceAlarmOperationNameMapping, DeviceCmdOperation, DeviceCmdOperationNameMapping, DeviceGroupOperation, DeviceGroupOperationNameMapping, DeviceReportsOperation, DeviceReportsOperationNameMapping, DevicesOperation, DevicesOperationNameMapping, FilesOperation, FilesOperationNameMapping, GeoPciOperation, GeoPciOperationNameMapping, GroupsOperation, GroupsOperationNameMapping, LicensesOperation, LicensesOperationNameMapping, ProfileTemplateOperation, ProfileTemplateOperationNameMapping, RfStandardOperation, RfStandardOperationNameMapping, RolesOperation, RolesOperationNameMapping, SchedulesOperation, SchedulesOperationNameMapping, TagsOperation, TagsOperationNameMapping, TenantsOperation, TenantsOperationNameMapping, UsagesOperation, UsagesOperationNameMapping, UsersOperation, UsersOperationNameMapping, WebhookSettingsOperation, WebhookSettingsOperationNameMapping } from "@core/types";

export const AUTH_OPERATION_NAME_MAP: AuthOperationNameMapping = {
    [AuthOperation.LOGIN]: "Login attempts.",
    [AuthOperation.LOGOUT]: "Logout.",
    [AuthOperation.TOKEN]: "Get the access token at first time.",
    [AuthOperation.TOKEN_REFRESH]: "Refresh the access token.",
    [AuthOperation._2FA_EMAIL]: "Send auth code thru email.",
    [AuthOperation._2FA_SMS]: "Send auth code thru sms.",
    [AuthOperation._2FA_CHECK]: "Check auth code."
};

export const USERS_OPERATION_NAME_MAP: UsersOperationNameMapping = {
    [UsersOperation.VERIFY_RESET_CODE]: "Verify email reset code.",
    [UsersOperation.RESET_PASSWORD]: "Reset the password.",
    [UsersOperation.UPDATE_PASSWORD]: "Update the password.",
    [UsersOperation.FORGOT_PASSWORD]: "Forgot the password.",
    [UsersOperation.UPDATE_SELF_PROFILE]: "Update self profile.",
    [UsersOperation.CREATE_USER]: "Create an user.",
    [UsersOperation.UPDATE_USER]: "Update an user.",
    [UsersOperation.DELETE_USER]: "Delete an user.",
    [UsersOperation.UPLAOD_USER_AVATAR]: "Upload the avatar.",
    [UsersOperation.SIGNUP_API_KEY]: "Sign up API key.",
    [UsersOperation.DELETE_API_KEY]: "Delete API key.",
    [UsersOperation.GET_USER_QRCODE]: "Get user QRCode",
    [UsersOperation.RE_INVITE_EMAIL]: "Regenerate the new invatation link"
};

export const LICENSE_OPERATION_NAME_MAP: LicensesOperationNameMapping = {
    [LicensesOperation.ASSIGN_LICENSE_TO_TENANT]: "Assign license to tenant.",
    [LicensesOperation.DELETE_LICENSE_FROM_TENANT]: "Remove license from tenant.",
    [LicensesOperation.OPERATION_ON_MULTIPLE_LICENSE]: "Operation on device(s) license.",
    [LicensesOperation.OPERATION_ON_SINGLE_LICENSE]: "Operation on a device license."
};

export const DEVICES_OPERATION_NAME_MAP: DevicesOperationNameMapping = {
    [DevicesOperation.DELETE_DEVICES]: "Delete deivce(s).",
    [DevicesOperation.UPDATE_DEVICE]: "Update single device information by id.",
    [DevicesOperation.UPDATE_DEVICE_CONFIG]: "Update configuration by id.",
    [DevicesOperation.DELETE_DEVICE_SPEED_TEST_REPORT]: "Remove all speed test records by MAC.",
    [DevicesOperation.DISABLE_REMOTE_ACCESS]: "Disable remote-access.",
    [DevicesOperation.UPDATE_DEVICE_INFO]: "Update multiple device information"
};

export const ALERT_CONFIG_OPERATION_NAME_MAP: AlertConfigOperationNameMapping = {
    [AlertConfigOperation.UPDATE_DEVICE_DATA_USAGE_SETTINGS]: "Update data usage settiings by id.",
    [AlertConfigOperation.UPDATE_ALERT_POLICY]: "Update alert policy by id"
};

export const DEVICE_COMMAND_OPERATION_NAME_MAP: DeviceCmdOperationNameMapping = {
    [DeviceCmdOperation.SEND_COMMAND]: "Send command to device.",
    [DeviceCmdOperation.BACKUP_CONFIGURATION]: "Backup configuration."
};

export const FILES_OPERATION_NAME_MAP: FilesOperationNameMapping = {
    [FilesOperation.GET_UPLOAD_URL]: "Retrieve upload url for file.",
    [FilesOperation.CREATE_FILE]: "Create file instance.",
    [FilesOperation.DELETE_FILE]: "Delete file.",
    [FilesOperation.SHARE_FILE]: "Share file",
    [FilesOperation.ACK_RECEIVED_FILE]: "Acknoledge receiving file.",
    [FilesOperation.UPLOAD_PCI_INFO_IN_BULK]: "Upload pci info file.",
    [FilesOperation.UPLAOD_DEVICE_INFO_IN_BULK]: "Upload device info file.",
    [FilesOperation.UPLOAD_ACTIVATE_DEVICE_IN_BULK]: "Upload activated device MAC file."
};

export const API_CONSUMERS_OPERATION_NAME_MAP: ApiConsumersOperationNameMapping = {
    [ApiConsumersOperation.DELETE_API_CONSUMER]: "Delete API key.",
    [ApiConsumersOperation.SIGNUP_API_KEY]: "Sign up API key."
};

export const DEVICE_ALARM_OPERATION_NAME_MAP: DeviceAlarmOperationNameMapping = {
    [DeviceAlarmOperation.SET_ALARM_READ]: "Set alert read.",
    [DeviceAlarmOperation.SET_ALL_ALARM_READ]: "Set all alerts read.",
    [DeviceAlarmOperation.GET_ALARM_COUNT]: "Get alarm count in date range.",
    [DeviceAlarmOperation.GET_ALARM_COUNT_BY_DATE]: "Get alarm count in one date."
};

export const DEVICE_REPORTS_OPERATION_NAME_MAP: DeviceReportsOperationNameMapping = {
    [DeviceReportsOperation.CREATE_REPORT]: "Create a report.",
    [DeviceReportsOperation.UPDATE_REPORT]: "Update report by id.",
    [DeviceReportsOperation.DELETE_REPORT]: "Delete report by id",
    [DeviceReportsOperation.EXPORT_REPORT]: "Export report by id"
};

export const GEO_PCI_OPERATION_NAME_MAP: GeoPciOperationNameMapping = {
    [GeoPciOperation.CREATE_GEO_PCI]: "Create a cell instance.",
    [GeoPciOperation.UPDATE_GEO_PCI]: "Update cell instance by id.",
    [GeoPciOperation.DELETE_GEO_PCI]: "Delete cell instance by id.",
    [GeoPciOperation.DELETE_ALL_GEO_PCI]: "Delete all cell instance."
};

export const GROUPS_OPERATION_NAME_MAP: GroupsOperationNameMapping = {
    [GroupsOperation.CREATE_GROUP_ROLE]: "Create a group user role.",
    [GroupsOperation.UPDATE_GROUP_ROLE]: "Update group user role by id.",
    [GroupsOperation.DELETE_GROUP_ROLE]: "Delete group user role by id.",
    [GroupsOperation.CREATE_GROUP]: "Create a group.",
    [GroupsOperation.UPDATE_GROUP]: "Update group by id.",
    [GroupsOperation.DELETE_GROUP]: "Delete group by id.",
    [GroupsOperation.CREATE_USER_INTO_GROUP]: "Invite user into group.",
    [GroupsOperation.UPDATE_USER_IN_GROUP]: "Update group user by id.",
    [GroupsOperation.DELETE_USER_IN_GROUP]: "Delete group user by id."
};

export const DEVICE_GROUP_OPERATION_NAME_MAP: DeviceGroupOperationNameMapping = {
    [DeviceGroupOperation.ASSIGN_GROUP_TO_DEVICE]: "Assign a group to device.",
    [DeviceGroupOperation.UNASSIGN_GROUP_FROM_DEVICE]: "Unassign group from device."
};

export const PROFILE_TEMPLATE_OPERATION_NAME_MAP: ProfileTemplateOperationNameMapping = {
    [ProfileTemplateOperation.CREATE_PROFILE_TEMPLATE]: "Create a profile template",
    [ProfileTemplateOperation.UPDATE_PROFILE_TEMPLATE]: "Update profile template by id.",
    [ProfileTemplateOperation.DELETE_PROFILE_TEMPLATE]: "Delete profile template by id.",
    [ProfileTemplateOperation.PUSH_TEMPLATE_TO_DEVICE]: "Push template to devices."
};

export const RF_STANDARD_OPERATION_NAME_MAP: RfStandardOperationNameMapping = {
    [RfStandardOperation.SAVE_RF_STANDARD]: "Save rf standard value."
};

export const ROLES_OPERATION_NAME_MAP: RolesOperationNameMapping = {
    [RolesOperation.CREATE_ROLE]: "Create a new role.",
    [RolesOperation.UPDATE_ROLE]: "Update role by id.",
    [RolesOperation.DELETE_ROLE]: "Delete role by id."
};

export const SCHEDULES_OPERATION_NAME_MAP: SchedulesOperationNameMapping = {
    [SchedulesOperation.CREATE_SCHEDULE]: "Create a schedule task.",
    [SchedulesOperation.UPDATE_SCHEDULE]: "Update schedule task.",
    [SchedulesOperation.DELETE_SCHEDULE]: "Delete schedule task by id.",
    [SchedulesOperation.RETRY_THE_TASK]: "Trigger retry on schedule task.",
    [SchedulesOperation.FORCE_START_THE_TASK]: "Trigger run-now on schedule task."
};

export const TAGS_OPERATION_NAME_MAP: TagsOperationNameMapping = {
    [TagsOperation.CREATE_TAG]: "Create a tag.",
    [TagsOperation.DELETE_TAG]: "Delete tag by id.",
    [TagsOperation.ASSIGN_TAG]: "Assign tag to devices."
};

export const TENANTS_OPERATION_NAME_MAP: TenantsOperationNameMapping = {
    [TenantsOperation.CREATE_TENANT]: "Create a tenant.",
    [TenantsOperation.UPDATE_TENANT]: "Update tenant by id.",
    [TenantsOperation.DELETE_TENANT]: "Delete tenant by id.",
    [TenantsOperation.INVITE_USER_TO_TENANT]: "Invite an user to tenant.",
    [TenantsOperation.UPDATE_USER_FROM_TENANT]: "Update user from tenant by id.",
    [TenantsOperation.DELETE_USER_FROM_TENANT]: "Delete user from tenant by id.",
    [TenantsOperation.SET_TENANT_STATUS]: "Set tenant activate status.",
    [TenantsOperation.UPLOAD_TENANT_LOGO]: "Upload tenant's logo image.",
    [TenantsOperation.ACCESS_TENANT]: "Access tenant.",
    [TenantsOperation.CREATE_ROLE_IN_TENANT]: "Create a role in tenant.",
    [TenantsOperation.UPDATE_ROLE_FROM_TENANT]: "Update role from tenant by id.",
    [TenantsOperation.DELETE_ROLE_FROM_TENANT]: "Delete role from tenant by id."
};

export const USAGES_OPERATION_NAME_MAP: UsagesOperationNameMapping = {
    [UsagesOperation.GET_BANDWIDTH_SUMMARY]: "Retireve overview bandwidth summary.",
    [UsagesOperation.GET_BANDWIDTH_BY_DEVICE]: "Retireve bandwidth data for single device.",
    [UsagesOperation.GET_BANDWIDTH_SUMMARY_BY_DEVICE]: "Retireve bandwidth summary for single device"
};


export const WEBHOOK_SETTINGS_OPERATION_NAME_MAP: WebhookSettingsOperationNameMapping = {
    [WebhookSettingsOperation.CREATE_WEBHOOK_PROFILE]: "Create webhook profile.",
    [WebhookSettingsOperation.UPDATE_WEBHOOK_PROFILE]: "Update webhook profile",
    [WebhookSettingsOperation.TEST_WEBHOOK_PROFILE]: "Test webhook profile"
};